import { Box, styled } from '@mui/material';

import { TTextFieldContainer } from './types';

export const StyledTextFieldContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})<TTextFieldContainer>(
  ({ fullWidth }) => ({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    minWidth: '0px',
    padding: '0px',
    margin: '0px',
    border: '0px',
    verticalAlign: 'top',
    width: fullWidth ? '100%' : 'auto',
  })
);
